import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { Datei, IPopupModel } from '@mwe/models';
import { openPdf } from '@mwe/utils';
import { PopupService } from '@mwe/services';
import { ButtonLinkComponent } from '../buttons/button-link/button-link.component';
import { ClickPreventDefaultDirective } from '../directives/click/click-prevent-default.directive';

@Component({
  selector: 'mwe-download-button',
  templateUrl: './download-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonLinkComponent, ClickPreventDefaultDirective],
})
export class DownloadButtonComponent {
  downloadPromise = input<() => Promise<Datei>>();
  label = input<string>();
  fileTitle = input<string>();
  errorTitleKey = input<string>();
  errorMessageKey = input<string>();
  errorSubmitButtonKey = input<string>();

  isLoading = signal<boolean>(false);
  private popupService = inject(PopupService);

  async openPdf(): Promise<void> {
    if (this.isLoading()) {
      return;
    }

    const downloader = this.downloadPromise();
    if (!downloader) {
      this.isLoading.set(false);
      return;
    }

    this.isLoading.set(true);
    try {
      const file = await downloader();
      if (file) {
        openPdf(file, this.fileTitle());
      } else {
        this.showDownloadErrorToast();
      }
    } catch {
      this.showDownloadErrorToast();
    } finally {
      this.isLoading.set(false);
    }
  }

  showDownloadErrorToast(): void {
    const model: IPopupModel = {
      id: 'download-error',
      titleKey: this.errorTitleKey(),
      messageKey: this.errorMessageKey(),
      showSubmitButton: true,
      submitButtonKey: this.errorSubmitButtonKey(),
      showCancelButton: false,
      iconColorClass: 'red',
      iconTypeClass: 'fa-exclamation',
    };
    this.popupService.open(model);
  }
}
